<template>
    <div class="success">
        <div class="success__body">
            <div class="success__icon">
                <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="24"
                        cy="24"
                        r="24"
                        fill="var(--app-main-accent-color)"
                        fill-opacity="0.15"
                    />
                    <path
                        d="M14 24L21 31L34 17"
                        stroke="var(--app-main-accent-color)"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>

            <h1 class="success__title">Label registered!</h1>
            <p class="success__subtitle">
                The label scanned was successfully assigned to the product.
            </p>

            <div v-if="product" class="success__product">
                <div class="success__product-info">
                    <div class="success__product-name">
                        {{ product.name }}
                        <template v-if="product.year"> {{ product.year }}</template>
                    </div>
                </div>
                <div class="success__product-img-wrap">
                    <img :src="productImage" :alt="product.name" class="success__product-img" />
                </div>
            </div>
        </div>

        <div class="success__actions">
            <button class="btn btn--secondary success__btn-home" type="button" @click="goHome">
                Home
            </button>
            <button
                class="btn btn_empty btn--secondary success__btn-another"
                type="button"
                @click="registerAnother"
            >
                Scan to register
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import productPlaceholder from '@/assets/images/product_placeholder.png'
import { useRegisterStore } from '@/stores/register'
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const registerStore = useRegisterStore()

const product = computed(() => registerStore.selectedProduct)

onMounted(async () => {
    if (!product.value) {
        await router.replace({ name: 'register-scan' })
    }
})

const productImage = computed(
    () => product.value?.product_image?.url || product.value?.bg_image?.url || productPlaceholder
)

const goHome = () => {
    registerStore.reset()
    router.push({ name: 'home' })
}

const registerAnother = () => {
    registerStore.reset()
    router.push({ name: 'register-scan' })
}
</script>

<style scoped lang="stylus">
.success
    padding 40px 16px calc(var(--app-footer-height) + 24px)
    display flex
    flex-direction column
    justify-content space-between
    min-height calc(var(--vh, 1vh) * 100 - var(--app-footer-height))

    &__body
        display flex
        flex-direction column
        align-items center
        gap 20px
        padding-top 20px

    &__icon
        display flex
        align-items center
        justify-content center

    &__title
        font-size 26px
        line-height 32px
        font-weight 700
        color var(--app-text-color)
        text-align center

    &__subtitle
        font-size 16px
        line-height 22px
        color var(--app-text-grey-color)
        text-align center
        max-width 280px
        margin 0

    &__product
        width 100%
        background-color var(--app-bg-secondary)
        border-radius 12px
        padding 12px 0 12px 12px
        display flex
        align-items stretch
        gap 12px

    &__product-info
        flex 1
        display flex
        flex-direction column
        gap 8px
        justify-content center

    &__product-name
        font-size 16px
        line-height 19px
        font-weight 500
        color var(--app-text-color-secondary)

    &__product-desc
        font-size 12px
        line-height 16px
        color var(--app-text-grey-color)
        display -webkit-box
        -webkit-line-clamp 2
        -webkit-box-orient vertical
        overflow hidden

    &__product-img-wrap
        flex-shrink 0
        width 80px
        height 100px

    &__product-img
        object-fit contain
        width 100%
        height 100%

    &__actions
        display flex
        flex-direction column
        gap 10px
        padding-top 24px

    &__btn-another
        width 100%

    &__btn-home
        width 100%
</style>
